export class EmailMarketingTag {
    constructor(
        public name: string
    ) { }
}
